import { render, staticRenderFns } from "./Chips.vue?vue&type=template&id=05e18d0a&"
import script from "./Chips.vue?vue&type=script&lang=js&"
export * from "./Chips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports